import { useCallback, useState } from 'react'

export const useScrollToneOptionIntoView = (
  scrollRef: React.RefObject<HTMLDivElement | null>
) => {
  const scrollToneOptionIntoView = useCallback(
    (toneId: number) => {
      const selectedElement = scrollRef.current?.querySelector(
        `[data-tone-id="${toneId}"]`
      )
      if (selectedElement) {
        selectedElement.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        })
      }
    },
    [scrollRef]
  )

  return scrollToneOptionIntoView
}

export const useToneOptionScrollHandler = (
  scrollRef: React.RefObject<HTMLDivElement | null>
) => {
  const [showLeftArrow, setShowLeftArrow] = useState(false)
  const [showRightArrow, setShowRightArrow] = useState(true)

  const handleScroll = useCallback(() => {
    if (!scrollRef.current) return

    const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current

    const isLeftArrowVisible = scrollLeft > 0
    const isRightArrowVisible = scrollLeft < scrollWidth - clientWidth - 10

    setShowLeftArrow(isLeftArrowVisible)
    setShowRightArrow(isRightArrowVisible)
  }, [scrollRef])

  return { showLeftArrow, showRightArrow, handleScroll }
}
